// import theme from ''

// const styles = theme => ({
//   fab: {
//     position: "fixed",
//     bottom: theme.spacing(2),
//     right: theme.spacing(2)
//   }
// });
//
// const bubble = {
//   color: theme.palette.info.light,
//   marginTop: theme.spacing(0.25),
//   marginBottom: theme.spacing(0.5),
//   marginLeft: theme.spacing(0.5),
//   marginRight: theme.spacing(0.5)
// };

export default theme => ({
  root: {
    backgroundColor: theme.palette.background.main,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
    // transition:
  },
  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "63px",
    flexShrink: 0
  },
  // bubble: {},

  bubble: {
    color: theme.palette.info.light,
    marginTop: theme.spacing(0.25),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // transition: theme.transitions.create(["padding", "width"], {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen
    // }),
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    transitionProperty: "box-shadow",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDelay: "0ms"
  },

  intent: {
    backgroundColor: theme.palette.background.main,
    borderColor: theme.palette.background.main,
    "&:hover, &:focus, &:active": {
      backgroundColor: theme.palette.primary.dark
    }
  },
  hierarchy: {
    backgroundColor: theme.palette.background.main,
    borderColor: theme.palette.background.main,
    "&:hover, &:focus, &:active": {
      backgroundColor: theme.palette.primary.dark
      // backgroundColor: theme.palette.background.main
    }
  },
  answer: {
    backgroundColor: theme.palette.background.main,
    borderColor: theme.palette.background.main,
    "&:hover, &:focus, &:active": {
      backgroundColor: theme.palette.primary.dark
      // backgroundColor: theme.palette.background.main
    }
  },
  slot: {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    "&:hover, &:focus, &:active": {
      backgroundColor: theme.palette.secondary.light
      // backgroundColor: theme.palette.secondary.main
    }
  },
  confirmation: {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    "&:hover, &:focus, &:active": {
      backgroundColor: theme.palette.secondary.light
      // backgroundColor: theme.palette.secondary.main
    }
  },
  back: {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    "&:hover, &:focus, &:active": {
      backgroundColor: theme.palette.secondary.light
      // backgroundColor: theme.palette.secondary.main
    }
  },
  bubbleAvatar: {
    padding: theme.spacing(0.5),
    // backgroundColor: `${theme.palette.background.light} !important`,
    backgroundColor: `${theme.palette.background.light}`,
    borderWidth: "1px",
    borderStyle: "solid",
    "&:hover, &:focus, &:active": {
      // backgroundColor: ""

      // opacity: 0.9,
      backgroundColor: `${theme.palette.background.light}`
    }
  }
});
